import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import cogoToast from 'cogo-toast';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { CALLBACK_REQUEST, CALLBACK_REQUEST_SUCCESS, CALLBACK_REQUEST_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* callbackRequest({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    /* body: { ticket_id, is_new_dashboard, callback_promised_timeline, agent_remark } */
    const response = yield call(apiCall, {
      // url: `${adminAPIURL}/v2/aina/ticket-system/tickets/${payload?.ticketId}/callback-request`,
      url: `${adminAPIURL}/v2/ticket-system/tickets/arrange-callback`,
      method: 'POST',
      headers: { ...filteredHeaders },
      data: payload?.data,
    });

    if (response.status === 200 || response.status === 201) {
      cogoToast.success(`${response?.data?.message || 'Callback request saved successfully'}`);
      yield put({
        type: CALLBACK_REQUEST_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message || 'Unable to save the callback request'}`);
      yield put({
        type: CALLBACK_REQUEST_ERROR,
        payload: response?.response?.data?.message,
      });
    }
  } catch (error) {
    cogoToast.error('Unable to save the callback request');
    yield put({ type: CALLBACK_REQUEST_ERROR, payload: error });
  }
}

export function* watchCallbackRequest() {
  yield takeEvery(CALLBACK_REQUEST, callbackRequest);
}

function* callbackRequestSaga() {
  yield all([fork(watchCallbackRequest)]);
}

export default callbackRequestSaga;
